<template>
    <div v-if="client">
        <!-- payment system payment methods -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Payment system payment methods</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.payments.paymentMethods"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- visible currencies -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Visible currencies</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.payments.visibleCurrencies"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

export default {
    name: 'client-settings-view-payments',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/payments.vue